<template>
  <GuDropdownMenu>
    <GuDropdownMenuTrigger hide-arrow as-child>
      <GuButton
        :id="`ag-grid-cell-renderer-User-Actions-${params.data?.['id'] || ''}`"
        variant="link"
        class="user-actions-context-menu-button"
        :aria-label="`View actions for application ID ${params.data?.['id'] || ''}`"
        role="button"
      >
        ...
      </GuButton>
    </GuDropdownMenuTrigger>

    <GuDropdownMenuContent>
      <GuDropdownMenuItem
        v-for="action in actions"
        :key="action.name"
        :class="action.cssClasses"
        :disabled="action.disabled"
        :aria-disabled="action.disabled"
        @click="action.action"
      >
        {{ action.name }}
      </GuDropdownMenuItem>
    </GuDropdownMenuContent>
  </GuDropdownMenu>
</template>

<script setup>
import { toRefs } from 'vue'

import { GuButton } from '@shared/gu-components/button'
import {
  GuDropdownMenu,
  GuDropdownMenuContent,
  GuDropdownMenuItem,
  GuDropdownMenuTrigger,
} from '@shared/gu-components/dropdown-menu'

import { useUserActions } from '@gu-datagrid-new/composables/cell-renderer-specific/UserActions'

defineOptions({
  name: 'UserActionsCellRenderer',
})

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const actions = useUserActions(params.value.column, params.value.node)
</script>
